export default __webpack_public_path__ + "static/media/marauders-map-v3-03-04.5790832c.jpg";